import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';
import { Environment } from './environment.d';

export const randysPizzaCustomerGroup = 'randys';
export const customerGroup = randysPizzaCustomerGroup;

export const venueConfig = {
	dev: 'randys_pizza_dev',
	prod: 'rp1',
};

const supportEmail = {
	anton_and_anni: 'anton_and_anni@smoothr.de',
};
const firebaseConfig = {
	randys: {
		apiKey: 'AIzaSyChoU3w8eUGbt1YFI2bRJunKQG00rKEFT0',
		authDomain: 'anton-and-anni.firebaseapp.com',
		projectId: 'anton-and-anni',
		storageBucket: 'anton-and-anni.firebasestorage.app',
		messagingSenderId: '581541930478',
		appId: '1:581541930478:web:31d02e95e45988bb1e1aff',
	},
};
export const environment: Environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: 'https://anton-and-anni-restaurant.com/allergen.pdf',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	enableCashPayment: true,
};
